/**
 * MIRROR of `packages/shared/src/openrouter-models.ts`.
 *
 * Why a mirror and not an import: `packages/web/Dockerfile` copies ONLY
 * `packages/web` into the build image and runs a bare `npm install` there, so a
 * workspace dependency on `@recruiter-buddy/shared` cannot resolve and would
 * break the production web image. Every other package imports the shared copy
 * directly; this is the one consumer that structurally cannot.
 *
 * Drift guard: `packages/shared/src/__tests__/openrouter-models.test.ts`
 * reads this file and asserts the ids match the shared list exactly.
 * If you edit one, edit both — that test will fail otherwise.
 */

export const OPENROUTER_MODEL_IDS = {
  claudeHaiku3: 'anthropic/claude-3-haiku',
  claudeSonnet5: 'anthropic/claude-sonnet-5',
  claudeOpus48: 'anthropic/claude-opus-4.8',
  deepseekChat: 'deepseek/deepseek-chat',
  gemma3nFree: 'google/gemma-3n-e4b-it:free',
  llama33_70bFree: 'meta-llama/llama-3.3-70b-instruct:free',
  gpt4Turbo: 'openai/gpt-4-turbo',
  gpt4o: 'openai/gpt-4o',
  gpt4oMini: 'openai/gpt-4o-mini',
} as const;
